import React from 'react';

const CreditPlansSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="cardGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6366f1" />
        <stop offset="100%" stopColor="#4f46e5" />
      </linearGradient>
      <linearGradient id="coinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
      <linearGradient id="chipGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fde68a" />
        <stop offset="100%" stopColor="#fcd34d" />
      </linearGradient>
    </defs>

    {/* Main credit card */}
    <rect x="8" y="18" width="48" height="28" rx="4" fill="url(#cardGrad)" stroke="#4338ca" strokeWidth="1.5" />

    {/* Magnetic stripe */}
    <rect x="8" y="26" width="48" height="6" fill="#1e1b4b" opacity="0.6" />

    {/* Chip */}
    <rect x="14" y="36" width="8" height="6" rx="1" fill="url(#chipGrad)" stroke="#f59e0b" strokeWidth="1" />

    {/* Chip pattern */}
    <g stroke="#f59e0b" strokeWidth="0.5" opacity="0.6">
      <line x1="16" y1="36" x2="16" y2="42" />
      <line x1="18" y1="36" x2="18" y2="42" />
      <line x1="20" y1="36" x2="20" y2="42" />
    </g>

    {/* Card number dots */}
    <g fill="white" opacity="0.8">
      <circle cx="28" cy="39" r="1.2" />
      <circle cx="31" cy="39" r="1.2" />
      <circle cx="34" cy="39" r="1.2" />
      <circle cx="37" cy="39" r="1.2" />

      <circle cx="41" cy="39" r="1.2" />
      <circle cx="44" cy="39" r="1.2" />
      <circle cx="47" cy="39" r="1.2" />
      <circle cx="50" cy="39" r="1.2" />
    </g>

    {/* Plan tiers indicator - stacked coins */}
    <g>
      {/* Bottom coin (Bronze tier) */}
      <ellipse cx="48" cy="52" rx="8" ry="4" fill="#cd7f32" stroke="#a0522d" strokeWidth="1" />
      <ellipse cx="48" cy="51" rx="8" ry="2" fill="#e9967a" opacity="0.5" />

      {/* Middle coin (Silver tier) */}
      <ellipse cx="48" cy="48" rx="8" ry="4" fill="#c0c0c0" stroke="#a9a9a9" strokeWidth="1" />
      <ellipse cx="48" cy="47" rx="8" ry="2" fill="#e8e8e8" opacity="0.6" />

      {/* Top coin (Gold tier) */}
      <ellipse cx="48" cy="44" rx="8" ry="4" fill="url(#coinGrad)" stroke="#d97706" strokeWidth="1" />
      <ellipse cx="48" cy="43" rx="8" ry="2" fill="#fef3c7" opacity="0.5" />

      {/* Dollar sign on top coin */}
      <text x="48" y="46" fontSize="8" fontWeight="bold" fill="#92400e" textAnchor="middle" fontFamily="Arial">
        $
      </text>
    </g>

    {/* Plan levels bars */}
    <g>
      <rect x="12" y="8" width="6" height="6" rx="1" fill="#10b981" opacity="0.8" />
      <rect x="20" y="6" width="6" height="8" rx="1" fill="#3b82f6" opacity="0.8" />
      <rect x="28" y="4" width="6" height="10" rx="1" fill="#8b5cf6" opacity="0.8" />
    </g>

    {/* Shine effect on card */}
    <ellipse cx="20" cy="24" rx="8" ry="4" fill="white" opacity="0.15" />
  </svg>
);

export default CreditPlansSvg;
